<template>

    <div class="ss top-page">

        <!--遮罩层-->
        <div class="record-mask" :style="{display: recordShow}"></div>
        <div class="record-mask-div" :style="{display: recordShow}">
            <div class="record-div-title">{{$t('lucky_draw.drawRecordTitle')}}</div>
            <ul>
                <li v-if="drawRecordList.length > 0" v-for="(i) in drawRecordList">
                    <span>{{i.add_time}}</span>
                    <span>{{i.name}}</span>
                </li>
                <li v-if="drawRecordList.length == 0" style="border-bottom:0px;">{{getDrawRecordResult}}</li>
            </ul>
            <div class="record-div-close">
                <div @click="closeRecord">X</div>
            </div>
        </div>

        <div class="return-back">
            <div class="back_left" @click="$router.go(-1)"></div>
        </div>
        <div class="return-back1" style="padding-top:1.1rem;">
            <div class="back-right" @click="$router.push('/about/6')">{{$t('lucky_draw.jump')}}</div>
        </div>
        <div class="return-back1" style="padding-top:2.14rem;">
            <div class="back-right" @click="drawRecord">{{$t('lucky_draw.record')}}</div>
        </div>
        <h4 class="return-title">
            {{$t('lucky_draw.title')}}
        </h4>
        <!-- 抽奖记录 -->
        <div class="record-position">
            <div class="get-record">
                <div class="trumpet"> </div>
                <div>
                    <ul class="draw-record" :style="`animation-duration: ${publicDrawRecordList.length * 5}s;`">
                        <li v-for="(i) in publicDrawRecordList">
                            {{$t('lucky_draw.userTitle')}} <span style="color:#00ff00">{{i.user}}</span> {{$t('lucky_draw.userEnd')}}
                            <span style="color:#00ff00">{{i.prizeName}} {{i.num}}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 抽奖记录的影子 -->
            <div class="get-record recodes">
                <div class="trumpet"> </div>
                <div>
                    <ul class="draw-record" :style="`animation-duration: ${publicDrawRecordList.length * 5}s;`">
                        <li v-for="(i) in publicDrawRecordList">
                            {{$t('lucky_draw.userTitle')}} <span style="color:#00ff00">{{i.user}}</span> {{$t('lucky_draw.userEnd')}}
                            <span style="color:#00ff00">{{i.prizeName}} {{i.num}}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="overall">
            <div class="circle-box">
                <div class="circle-items">
                    <div class="circle" v-for="(item,index) in circles" :key="index" :style="`position:absolute;left:49%;top:49%; z-index:999999; transform:rotate(${index*360/circles}deg) translate(0,-4.1rem);`">
                    <span></span>
                    </div>
                </div>
                <div class="zp-box">
                    <div class="panzi">
                        <div class="bck-box" :style="` transform: rotate(${-90+180/list.length}deg)`">
                            <div class="bck" v-for="(i, index) in list" :key="index" :style="`transform: rotate(${-index*360/list.length}deg) skew(${-90 + 360/list.length}deg);`" >
                            </div>
                        </div>

                        <div class="jiang" :style="`transform: rotate(${-index*360/list.length}deg) translateY(-2.2rem);`" v-for="(i,index) in list" :key="index">
                            <span class="title">{{i.title}}</span>
                            <div class="img">
                                <img :src="'http:'+i.logo" alt="">
                            </div>
                        </div>
                    </div>
                    <button class="start-btn" @click="start(1)"></button>
                </div>
            </div>
        </div>

        <div class="hint-text" >
            <span><b>{{drawNum}}</b> {{$t('lucky_draw.notice')}}</span>
            <span><b>{{money}}</b> {{$t('lucky_draw.notices')}}</span>
            <div class="buttons-div">
                <button class="buttons" style="margin-right: 0.9rem;" @click="start(2)">{{$t('lucky_draw.button')}}</button>
                <button class="buttons" @click="start(1)">{{price}} {{ $t('lucky_draw.buttons') }}</button>
            </div>
        </div>
      <!--<div class="start-btns" style="text-align:center">
            <button class="buttons" @click="starts(2)">{{$t('lucky_draw.button')}}</button>
            <button class="buttons" @click="start(1)">{{price}} {{ $t('lucky_draw.buttons') }}</button>
        </div> -->
        <div  class="illustrate">
            <div>{{ $t("lucky_draw.rulesTitle") }}</div>

            <div style="margin-top:20px; text-align:left;">
                <p>{{$t('lucky_draw.rulesInfo1')}}</p>
                <p>{{$t('lucky_draw.rulesInfo2')}}</p>
                <p>{{$t('lucky_draw.rulesInfo3')}}</p>
                <p>{{ $t("lucky_draw.rulesInfo4") }}</p>
            </div>

        </div>
    </div>

</template>

<script>
    import Fetch from '../../utils/fetch'
    import {Dialog} from 'vant';
    import { BlockList } from 'net';

    export default {
        name: 'lucky_draw',
        computed: {
        },
        data() {
            return {

                loading: false, // 抽奖执行状态，防止用户多次点击
                circles: 24,
                panziElement: null,
                drawRecordList: [], // 抽奖记录 国际化获取
                recordClick: false, // 抽奖记录单次点击
                getDrawRecordResult: this.$t('lucky_draw.recordLoading'), // 抽奖记录获取状态

                list: [],       // 奖品列表
                drawNum: 0 ,    // 可用抽奖次数
                money: 0,       // 用户可用余额
                price: 0,       // 用余额抽奖的售价

                drawId: 0,      // 中奖的奖品ID 用来计算转盘索引的
                drawTitle: '',  // 中奖的奖品标题 后端自动适配国际化
                rewardNum: 0,   // 抽中的奖品数量或者说 金额

                recordShow: 'none', // 抽奖记录是否显示
                publicDrawRecordList: [] // 公用抽奖记录列表
            }
        },
        created() {
            this.$parent.footer('walfare', false);
        },
        mounted() {
            // 获取奖品列表
            this.getPrizeList();
            // 获取公用假数据抽奖列表
            this.getPublicDrawRecordList();
        },
        methods: {
            //开始抽奖
            async start(type) {

                // 只能点击一次
                // if (this.loading || this.drawId != 0) return ;
                // 判断是否有可用抽奖次数
                if (type == 2 && this.drawNum == 0) return false;
                // 判断是可用余额是否够抽奖使用
                if (type == 1 && this.money < this.price) return false;
                // 屏蔽下次旋转
                this.loading = true;
                // 获取转盘
                this.panziElement = document.querySelector('.panzi');
                // 开始旋转
                // this.panziElement.style.animation = "mymove 3s infinite"
                this.panziElement.classList.add('wr');
                // 获取奖品并旋转转盘
                await this.getDrawResult(type);
                this.winCallback();
            },
            starts() {

                Dialog.alert({
                        message: this.$t('lucky_draw.notice2'),
                        confirmButtonText: window.vm.$i18n.t('utils.confirm')
                    });
            },
            //中奖返回方法
            winCallback() {

                // 清除动画并重置角度
                this.panziElement.classList.remove('wr');
                this.panziElement.style.transform = 'rotate(0deg)';
                // 获取到奖品 移除旋转效果 放入新的旋转 新的旋转执行三秒
                var length = this.list.length;
                var i      = 0;
                for (i = i; i < length; i ++) {
                    if (this.list[i].id == this.drawId) break;
                }

                // 旋转度
                var rotation = i * (360 / length);
                var ss =  5 * 360 + rotation + 'deg';
                document.styleSheets[0].insertRule(
                    `@keyframes example {
                        to {
                            transform: rotate(` + ss + `);
                        }
                    }`,
                );

                this.panziElement.style.animation = 'example 3s';
                this.panziElement.style.transform = 'rotate(' + rotation + 'deg)';
                // 释放抽奖点击 释放抽奖ID

                // 因为动画时间为 3s ，所以这里3s后获取结果，其实结果早就定下了，只是何时显示，告诉用户
                setTimeout(() => {

                    // 弹出得奖窗口并刷新下页面
                    Dialog.alert({
                        message: this.drawTitle,
                        confirmButtonText: window.vm.$i18n.t('utils.confirm')
                    }).then(() => {
                        // 刷新页面
                        // this.$router.go(0);
                        window.location.reload();
                    });

                }, 3000)
            },
            // 获取奖品列表
            getPrizeList() {

                Fetch('/lucky_draw', {
                    ...this.data
                }).then((r) => {
                    this.list    = r.data.prizelist; // 奖品列表
                    this.drawNum = r.data.luckynum; // 可用抽奖次数
                    this.money   = r.data.money; // 可用余额
                    this.price   = r.data.price; // 每次抽奖所需金额
                });
            },
            // 获取公用假数据抽奖记录 小喇叭
            getPublicDrawRecordList() {
                // 从国际化文件中获取
                this.publicDrawRecordList = this.$t('lucky_draw.recordList');
            },
            // 获取抽奖结果
            async getDrawResult(type) {

                await Fetch('/lucky_draw/get_lucky_result?type=' + type, {
                    ...this.data
                }).then((r) => {
                    this.drawNum    = r.data.luckynum; // 设置可用抽奖次数
                    this.drawId     = r.data.drawId; // 设置获得的奖品ID
                    this.drawTitle  = r.data.title; // 中奖标题
                    this.money      = r.data.money; // 用户剩余金额
                    this.rewardNum  = r.data.reward_num; // 抽中的奖品数量
                });
            },
            // 抽奖记录
            async drawRecord() {
                // 屏蔽连续点击
                if (this.recordClick) return false;
                this.recordClick = true;
                // 显示抽奖记录弹窗
                this.recordShow = 'block';

                await Fetch('/lucky_draw/get_draw_record', {
                    ...this.data
                }).then((r) => {

                    this.drawRecordList = r.data;
                    if (this.drawRecordList == 0) this.getDrawRecordResult = this.$t('lucky_draw.noRecord'); // 没有抽奖记录
                });

            },
            // 关闭抽奖记录弹窗
            closeRecord() {
                // 关闭弹窗
                this.recordShow = 'none';
                // 恢复按钮可点击状态
                this.recordClick = false;
                // 抽奖记录重置为加载中
                this.getDrawRecordResult = this.$t('lucky_draw.recordLoading');
            }
        }
}
</script>


<style lang="scss" scoped id="aa">
    $zp_size: 9rem; // 转盘尺寸
    $btn_size: 1.5rem; // 抽奖按钮尺寸
    $time: 3s; // 转动多少秒后停下的时间
    .ss {
        background: linear-gradient(180deg, #652fe0, #2d0987);
        width: 100%;
        height: 100vh;
        overflow-x:hidden;
    }

    .ss {
        background-color: '#6225d8';

    }
    .return-back{
      width: 50%;
      height: 1.4rem;
      position: fixed;
      left: 0;
      top: 0;
      // padding:0 24px;
      img{
        width: .8rem;
        height: .8rem;
        margin-top: 16px;
      }
    }

    .return-back1 {
        z-index: 999;
      width: auto;
      height: 1.4rem;
      position: fixed;;
      right: 0;
      top: 0;
      // padding:0 24px;
      .back-right {

        width: auto;
        min-width: 2.2rem;
        height: 0.8rem;
        border: 1px solid #fff;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #612ad0;
        font-weight:bold;
        border-radius: 14px 0 0 14px;
        // padding: 0.1rem;
        font-size: 15px;
      }
    }
    .back_left {
        margin-top:0.27rem;
    }
    .return-title{
      color: #fff;
      font-size: .6rem;
      margin-top: 0.24rem;
      font-weight: normal;
      text-align: center;
    }
    .hint-text{
        background: url(./back_image.png) center no-repeat;
        width: 100%;
        height: 11rem;
        background-size: contain;
        position: relative;
        // margin: 0 auto;
        margin-left: 6px;
        margin-top: -8rem;
        text-align: center;
        font-size: 15px;
        color: #fff;
        span {
            padding-top: 7.2rem;
            color:#ff2900;
            display: block;
            b {
                color: #fff;
            }
        }
        span:nth-child(2) {
            padding-top:0.2rem;
        }
    }
    .buttons-div {
        position: absolute;
        left: 48%;
        bottom: .8rem;
        width: 80%;
        transform:
        translate(-50%, -50%);
    }
    .buttons {

        width: 3.1rem;
        height: 1rem;
        display: inline-block;
        font-size: 16px;
        font-weight: bold;
        // border: 1px solid red;
    }

    .overall {
      display: flex;
      justify-content: center;
      align-items: center;
      margin:0 auto;
      margin-top: 2.7rem;
      margin-bottom: 1.0rem;
      background: #f18d4a;
      padding:5px;
      border: 4px solid #ffff70;
      border-radius: 50%;
      width: $zp_size;
      height: $zp_size;
      position: relative;
      z-index: 2;
      zoom: .9;
    }
    .circle-box{
      width: 100%;
      height: 100%;
      background: #6e23f6;
      border-radius: 50%;
      position: relative;
      .circle-items{
        width: 100%;
        height: 100%;
        border-radius: 50%;
        position: relative;
      }
      .circle{
        span{
          width:8px;
          height: 8px;
          background: #fff;
          display: block;
          border-radius: 50%;
          box-shadow: 1px 2px 4px #4f17b5;
        }

      }
      .circle-items .circle:nth-child(odd) span{
          background: #f18d4a;
        }
    }


    .zp-box {

        user-select: none;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        width: 7.6rem;
        height: 7.6rem;
      /* 抽奖按钮 */
        .start-btn {
            display: inline-block;
            background: url(./start_btn.png) center no-repeat ;
            background-size: cover;
            position: relative;
            z-index: 2;
            cursor: pointer;
            width: 1.8rem;
            height: 2.3rem;
            display: flex;
            justify-content: center;
            align-items: center;
            color: white;
            font-size: 0;
            font-weight: bold;
            box-sizing: border-box;
            position: relative;
            z-index: 2;
        }
        /* 盘子样式 */

        .panzi {
            overflow: hidden;
            border-radius: 50%;
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            border: 10px solid #766ff5;
            box-sizing: border-box;
            /* 每个奖项的样式 */
            .jiang {
                position: absolute;
                .title {
                    font-weight: bold;
                    font-size: 12px;
                    text-align: center;
                    display: block;
                    // display: inline-block;
                    white-space:pre-wrap;
                    word-wrap : break-word ;
                    overflow: hidden ;
                    color: #fff;
                    width: 100%;
                    margin: 0 auto;
                }

                .img {
                    margin: 0.2rem auto;
                    width: .9rem;
                    overflow: hidden;
                    color: white;
                    img {
                        max-width: 100%;
                    }
                }
            }
            .jiang:nth-child(2n) .title{
                color:#6628de;
            }
        }
        .bck-box {
            overflow: hidden;
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            // background: blue;
            border-radius: 50%;

            /* 转盘扇形背景 */
            .bck {
                box-sizing: border-box;
                position: absolute;
                width: 100%;
                height: 100%;
                opacity: 1;
                top: -50%;
                left: 50%;
                transform-origin: 0% 100%;
                // transform:skew(30deg);
            }
            /* 转盘背景色 */
            .bck:nth-child(2n) {
                background: #6628de;
            }
            .bck:nth-child(2n + 1) {
                background: #e8e0fd;
            }
        }

        .wr {
            animation:mymove 15s infinite;
            -webkit-animation:mymove 15s infinite; /*Safari and Chrome*/
        }

        @keyframes mymove
        {
            to {
                transform: rotate(50 * 360deg + 360deg);
            }
        }

        @-webkit-keyframes mymove /*Safari and Chrome*/
        {
           to {
                transform: rotate(50 * 360deg + 360deg);
            }
        }
    }

    @keyframes seamless-scrolling {
        0% {
            transform: translateX(0px);
        }
        100% {
            transform: translateX(-100%); //Q2
        }
    }

    @-webkit-keyframes seamless-scrolling /*Safari and Chrome*/
    {
        0% {
            transform: translateX(0px);
        }
        100% {
            transform: translateX(-100%); //Q2
        }
    }

    .illustrate {
        background: #4c16b4;
        margin: 10px 20px 0 20px;
        padding: 0 10px;
        font-size:16px;
        text-align:center;
        color: #fff;
        border: 0.3rem solid #612ad0;
        border-top: 0.48rem solid #612ad0;
        // border-bottom: 0;
        border-radius: 0.2rem 0.2rem 0 0;

        div:nth-child(1) {
            background: url(./illustrate.png) center no-repeat;
            width: 80%;
            height: 1.3rem;
            background-size: contain;
            position: relative;
            margin: 0 auto;
            font-size: 22px;
            margin-top: -0.46rem;
            line-height: 1.3rem;
            color: #ff2900;
        };
        div {
            p {
                line-height: 25px;
                margin-bottom: 20px
            }
        }
    }
    .record-position {
        position: absolute;
        width: 72%;
    }
    .get-record {
        display:flex;
        // width: 72%;
        height: 0.8rem;
        line-height: 0.78rem;
        margin-top: 0.7rem;
        background: linear-gradient(45deg, rgb(212, 208, 208), transparent);
        border-radius: 0 0.35rem 0.35rem 0;
        opacity: 1;
        div {
            width: 90%;
            height: 0.8rem;
            margin-left: 2px;
            overflow:hidden;
            .draw-record {
                font-size:10px;
                color:#fff;
                width: fit-content; // Q1
                white-space: nowrap; // 内容不换行
                animation-name: seamless-scrolling; // Q3
                animation-timing-function: linear; // 动画速度曲线，匀速
                animation-iteration-count: infinite; // 动画循环无限次播放

                li {
                    display: inline-block;
                    margin-right: 30px;
                }
            }
        }

        .trumpet {
            background: url(./trumpet.png) center no-repeat;
            background-size: contain;
            width: 0.45rem;
            height: 0.45rem;
            margin-top: 0.2rem;
            margin-left: 0.4rem;
        }
    }
    .recodes {
        margin-top: -0.2rem;
        opacity: 0.2;
    }

    .record-mask {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: black;
        z-index: 3;
        opacity: 0.5;
    }

    .record-mask-div {
        width: 80%;
        height: 10rem;
        border: 1px solid #fff;
        border-radius: 10px;
        position: fixed;
        top: 4rem;
        left: 0;
        right: 0;
        margin: 0 auto 0 auto;
        background-color:#fff;
        z-index: 4;

        .record-div-title {
            position: absolute;
            top: 0;
            width: 100%;
            height: 1rem;
            line-height: 1.3rem;
            text-align: center;
            font-size: 24px;
            font-weight: bold;
            color: #2d0987;
        }
        .record-div-close {
            position: absolute;
            bottom: 0;
            left:0;
            right:0;
            width: 100%;
            height: 2rem;
            text-align: center;
            font-size: 24px;
            font-weight: bold;
            color: #2d0987;
            background: #fff;
            opacity: 0.5;
            border-radius: 0 0 10px 10px;
            div {
                position: absolute;
                left:0;
                right:0;
                margin: 20px auto;
                width: 40px;
                height: 40px;
                line-height: 40px;
                border-radius: 20px;
                background: black;
            }
        }

        ul::-webkit-scrollbar {
            width: 3px;
            height: 5px;
        }

        ul::-webkit-scrollbar-thumb {
            border-radius: 3px;
            background: rgba(92, 11, 206, 0.7);
        }

        ul {
            width:100%;
            position: absolute;
            top: 1.5rem;
            text-align: center;
            height: 8rem;
            overflow-y: scroll;
            // scrollbar-face-color: #652fe0;
            li:after {
                clear: both;
                display: block;
                content: '';
            }
            li {
                line-height: 33px;
                border-bottom: 1px solid #3c3748;
                margin: 5px;
                padding: 5px 10px;
                font-size: 16px;
                color: #692fd6;
                span:nth-child(1){
                    float: left;
                }
                span:nth-child(2){
                    font-weight: bold;
                    float: right;
                }
            }
        }

    }
</style>
